import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeModeProvider } from "./context/ThemeModeContext";

const container = document.getElementById("root");

if (container) {
  const app = (
    <React.StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <ThemeModeProvider>
            <App />
          </ThemeModeProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );

  if (container.hasChildNodes()) {
    hydrateRoot(container, app);
  } else {
    const root = createRoot(container);
    root.render(app);
  }

  // Tell the start-up safety net in index.html that the app is running.
  window.__COACHHUB_BOOTED__ = true;
  window.__COACHHUB_HIDE_BOOT_MESSAGE__?.();
}



